export default (width: number): void => {
  window.addEventListener("load", () => {
    if (screen.width < width) {
      const mvp = document.querySelector("meta[name=viewport]");
      mvp?.setAttribute("content", `user-scalable=no,width=${width}`);
    }
  });
};
